import React, { useState } from "react";
import { HiDotsHorizontal } from "react-icons/hi";
import ReactPaginate from "react-paginate";
import { Modal, Button, Table, Form, Collapse } from "react-bootstrap";
import "../css/pagination.css";
import axios from "axios";
import { FaWhatsapp } from "react-icons/fa";
import { FaCheckDouble } from "react-icons/fa6";
import { FaFileSignature } from "react-icons/fa6";

const AttandanceListComp = ({
  members,
  eventname,
  itemsPerPage,
  reloadTable,
}) => {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");

  const handlePageClick = (event) => {
    const newPage = event.selected;
    setCurrentPage(newPage);
  };

  const offset = currentPage * itemsPerPage;
  const currentPageData = members.slice(offset, offset + itemsPerPage);

  const handleClose = () => setShow(false);
  const handleShow = (row) => {
    setSelectedRow(row);
    setShow(true);
  };
  const fileExcusse = async (item) => {
    console.log(item);
    let data = {
      name: item.name,
      surname: item.surname,
      cell: item.cell,
      tagid: item.tagid,
      event_title: eventname,
      scanner: "Admin",
      type: item.type,
    };
    console.log(data);
    try {
      const res = await axios.post(
        `https://ntcapi-a4fdbbdfb3gactbd.southafricanorth-01.azurewebsites.net/api/save-excuse`,
        data
      );
      let retcode = res.data;
      reloadTable(reloadTable);
      setLoading(false);
    } catch (error) {
      //stop loading
      setLoading(false);
      console.log("post error =>" + error);
    }
  };
  const sendMessage = async () => {
    try {
      const res = await axios.post(
        `https://ntcapi-a4fdbbdfb3gactbd.southafricanorth-01.azurewebsites.net/api/save-message`,
        {
          names: selectedRow.name,
          email: selectedRow.cell,
          message,
          status: "sent",
        }
      );
      let retcode = res.data.message;
      if (retcode === "Message saved") {
        setShow(false);
        alert("Message send and saved..");
      }
      //stop loading
      setLoading(false);
    } catch (error) {
      //stop loading
      setLoading(false);
      console.log("post error =>" + error);
    }
  };
  return (
    <div>
      <Table striped bordered hover className="shadow">
        <thead>
          <tr>
            <th>#.</th>
            <th>Name</th>
            <th>Surname</th>
            <th>Cell</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {currentPageData.map((row, index) => (
            <tr key={index}>
              <td>
                <small>{index}</small>
              </td>
              <td>
                <small>{row.name}</small>
              </td>
              <td>
                <small>{row.surname}</small>
              </td>
              <td>
                <small>{row.cell}</small>
              </td>
              <td>
                {row.attendance_status === "Attended" ? (
                  <small style={{ fontWeight: "bold", color: "#3bc0c3" }}>
                    Attended
                  </small>
                ) : (
                  <small style={{ fontWeight: "bold", color: "#33afe0" }}>
                    Did not attend
                  </small>
                )}
              </td>
              <td>
                <Button
                  className="bg-body text-black border-0"
                  onClick={() => handleShow(row)}
                >
                  <HiDotsHorizontal />
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <ReactPaginate
        previousLabel={"previous"}
        nextLabel={"next"}
        breakLabel={"..."}
        pageCount={Math.ceil(members.length / itemsPerPage)}
        marginPagesDisplayed={2}
        pageRangeDisplayed={5}
        onPageChange={handlePageClick}
        containerClassName={"pagination"}
        activeClassName={"active"}
      />
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title> Extra Menu</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedRow ? (
            <div className="row">
              <div className="row">
                <div className="col-md-6">
                  <Button
                    className="mt-3 w-100 rounded-0"
                    variant="success"
                    onClick={() => setOpen(!open)}
                    style={{ height: 70 }}
                  >
                    <FaWhatsapp className="me-2" />
                    Send SMS Message
                  </Button>
                </div>
                <div className="col-md-6">
                  <Button
                    className="mt-3 w-100 rounded-0"
                    variant="info"
                    type="submit"
                    disabled={
                      selectedRow.attendance_status === "Attended"
                        ? true
                        : false
                    }
                    style={{ height: 70 }}
                    onClick={() => {
                      fileExcusse(selectedRow);
                    }}
                  >
                    <FaFileSignature className="me-2" />
                    Submit Excuse
                  </Button>
                </div>
              </div>
              <div className="row">
                <Collapse in={open}>
                  <Form>
                    <Form.Group className="mb-2" controlId="formBasicEmail">
                      <Form.Label>
                        <small className="m-0">
                          <b>Name</b>
                        </small>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        disabled
                        placeholder="Enter naMe"
                        value={selectedRow.name}
                      />
                    </Form.Group>
                    <Form.Group className="mb-2" controlId="formBasicEmail">
                      <Form.Label>
                        <small className="m-0">
                          <b>From</b>
                        </small>
                      </Form.Label>
                      <Form.Control
                        type="number"
                        disabled
                        placeholder="Enter number"
                        value={selectedRow.cell}
                      />
                    </Form.Group>
                    <Form.Group>
                      <label for="exampleFormControlTextarea1">
                        Type message here
                      </label>
                      <textarea
                        class="form-control"
                        id="exampleFormControlTextarea1"
                        rows="3"
                        onChange={(e) => setMessage(e.target.value)}
                      ></textarea>
                    </Form.Group>

                    <Button
                      className="mt-3 p-2 rounded-0 d-flex justify-content-end"
                      variant="primary"
                      onClick={sendMessage}
                    >
                      <FaCheckDouble className="me-2" />
                      Send Message
                    </Button>
                  </Form>
                </Collapse>
              </div>
            </div>
          ) : (
            <p>No data available.</p>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};
export default AttandanceListComp;
